var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"id":"activities-list","title":_vm.$root.translate('Activity:::Activities', {}, 2),"is-root":true,"status":_vm.page_status,"waiting":_vm.waiting},on:{"statused":_vm.statused}},[(_vm.is_at_least_administrator)?_c('activities-list'):_c('activities-grid',{attrs:{"can-preview":true,"can-bulk-assign":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }